import classNames from 'classnames';
import './divider.css';

export type DividerPropsType = {
  content: string;
  className?: string;
};

function Divider({ content, className }: DividerPropsType) {
  return (
    <div className={classNames('divider', 'w-100 mx-0 my-6 border-b text-center', className)}>
      {content && <span className='bg-white px-0'>{content}</span>}
    </div>
  );
}

export default Divider;
